import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import { useState, useEffect } from "react";
import { getCeremoniasWithAcolitos } from "../../helpers/ceremonias";
import { Box, Button, Fade, Typography } from "@mui/material";
import { Calendar } from "../../common/components";
import dayjs from "dayjs";

export const Ceremonias = () => {
  //Nombre de la pestaña
  document.title = "Ceremonias";
  const [loading, setLoading] = useState(true);
  const [startDate, setStartDate] = useState({
    fecha: null,
  });
  const [endDate, setEndDate] = useState({
    fecha: null,
  });

  const [rows, setRows] = useState([]);

  useEffect(() => {
    if (!loading) return;
    const today = dayjs();

    let stDate = startDate.fecha;
    let edDate = endDate.fecha;

    if (startDate.fecha == null || startDate.fecha == "") {
      //   Fecha de inicio de hace 15 días
      stDate = today.subtract(15, "days").format("YYYY-MM-DD");
      setStartDate({
        fecha: stDate,
      });
    }

    if (endDate.fecha == null || endDate.fecha == "") {
      //   Fecha de fin de hoy más 15 días más
      edDate = today.add(15, "days").format("YYYY-MM-DD");
      setEndDate({
        fecha: edDate,
      });
    }

    getCeremoniasWithAcolitos(null, stDate, edDate).then((ceremonias) => {
      const processedCeremonias = ceremonias.map((ceremonia) => ({
        ...ceremonia,
        acolitos: ceremonia.acolitos || [], // Asegurar que siempre haya un arreglo
      }));
      setRows(processedCeremonias);

      setLoading(false);
    });
  }, [loading]);

  const columns = [
    { field: "dia", headerName: "Día", width: 150 },
    { field: "horario", headerName: "Hora", width: 150 },
    {
      field: "tipo",
      headerName: "Tipo de ceremonia",
      width: 200,
    },

    {
      field: "clase",
      headerName: "Clase",
      width: 80,
    },
    {
      field: "color_ornamentos",
      headerName: "Color de ornamentos",
      width: 200,
    },
    {
      field: "festividad",
      headerName: "Festividad",
      width: 300,
    },
    {
      field: "acolitos",
      headerName: "Acólitos",
      width: 400,
      renderCell: (params) => {
        if (!params.value || params.value.length === 0) {
          return <Typography>No hay acólitos</Typography>;
        }

        return (
          //Ordenar los acólitos por puesto, si es Misa Cantada el orden es:
          // Maestro de Ceremonias, Turiferario, Acólito 1, Acólito 2, CRUZ, HACHA 1, HACHA 2, HACHA 3, HACHA 4
          <div>
            {params.value
              .sort((a, b) => {
                if (a.puesto === "Maestro de Ceremonias") return -1;
                if (b.puesto === "Maestro de Ceremonias") return 1;
                if (a.puesto === "Turiferario") return -1;
                if (b.puesto === "Turiferario") return 1;
                if (a.puesto === "Acólito 1") return -1;
                if (b.puesto === "Acólito 1") return 1;
                if (a.puesto === "Acólito 2") return -1;
                if (b.puesto === "Acólito 2") return 1;
                if (a.puesto === "CRUZ") return -1;
                if (b.puesto === "CRUZ") return 1;
                if (a.puesto === "HACHA 1") return -1;
                if (b.puesto === "HACHA 1") return 1;
                if (a.puesto === "HACHA 2") return -1;
                if (b.puesto === "HACHA 2") return 1;
                if (a.puesto === "HACHA 3") return -1;
                if (b.puesto === "HACHA 3") return 1;
                if (a.puesto === "HACHA 4") return -1;
                if (b.puesto === "HACHA 4") return 1;
                return 0;
              })
              .map((acolito) => (
                <Typography key={acolito.id_rol} fontSize={14}>
                  <strong>{acolito.puesto}:</strong> {acolito.nombre}
                </Typography>
              ))}
          </div>
        );
      },
    },
  ];

  return (
    <Fade in={true} timeout={1000}>
      <div>
        <Box sx={{ display: "flex", paddingLeft: 5 }}>
          {/* Aquí irán dos inputs la cual serán dos fechas de inicio y fin */}
          <Box sx={{ marginRight: 5 }}>
            <Calendar
              fecha={startDate?.fecha ? dayjs(startDate.fecha) : null}
              setFecha={setStartDate}
              label={"Desde el día"}
            />
          </Box>
          <Box sx={{ marginRight: 3 }}>
            <Calendar
              fecha={endDate?.fecha ? dayjs(endDate.fecha) : null}
              setFecha={setEndDate}
              label={"al día"}
            />
          </Box>
          {/* Botón para aplicar filtros */}
          <Button
            onClick={() => {
              setLoading(true);
            }}
          >
            Buscar
          </Button>
          <Typography
            id="transition-modal-title"
            variant="h4"
            color="primary"
            fontWeight={900}
            position={"absolute"}
            right={50}
          >
            CEREMONIAS
          </Typography>
        </Box>
        <div style={{ width: "100%", padding: 20 }}>
          <DataGrid
            rows={rows}
            columns={columns}
            getRowHeight={(params) => {
              const numberOfAcolitos = params.model.acolitos.length;
              const baseHeight = 3;
              const extraHeightPerAcolito = 22;
              return baseHeight + numberOfAcolitos * extraHeightPerAcolito;
            }}
            slots={{
              toolbar: GridToolbar,
            }}
            loading={loading}
            onRowClick={(row) => {
              window.location.href = `/ceremonias/${row.row.id}`;
            }}
          />
        </div>
      </div>
    </Fade>
  );
};
